import React, { useEffect } from 'react';
import UserActivity from 'src/auth/userActivity';
import LoginAuthorization from 'src/components/LoginAuthorization/LoginAuthorization';
import AppDialogs from 'src/dialogs';
import { dispatch } from 'src/redux/config/configureStore';
import { setViewAsEmail } from 'src/redux/slices/investor.slice';
import MainModule from './MainModule.Investor';

//View as email session key
const VIEW_AS_EMAIL = 'view_as_email';

/**
 * Main component
 */
const Main: React.FC = () => {
  //Update the email if this is a view as session
  useEffect(() => {
    //try to get the email from the local storage or session storage
    let emailFromStorage: string = localStorage.getItem(VIEW_AS_EMAIL);

    //if exists in local storage, move it to session storage
    if (emailFromStorage) {
      localStorage.removeItem(VIEW_AS_EMAIL);
      sessionStorage.setItem(VIEW_AS_EMAIL, emailFromStorage);
    }

    //get the email from the session storage
    if (!emailFromStorage) emailFromStorage = sessionStorage.getItem(VIEW_AS_EMAIL);

    //if no email in session storage, return
    if (!emailFromStorage) return;

    //set the email in the redux store
    dispatch(setViewAsEmail(emailFromStorage));
  }, []);

  return (
    <LoginAuthorization>
      <MainModule />
      <AppDialogs />
      <UserActivity timeout={1000 * 60 * 60 * 2} />
    </LoginAuthorization>
  );
};

export default Main;
